import { container } from '@/container';

export const PrintOrderTicketsMixin = {
    computed: {
        showTicketButtons() {
            return container.receiptPrinter.canPrintTicketsForOrder(this.order);
        },
    },

    methods: {
        printIndividualTickets() {
            this.isPrinting = true;
            container.receiptPrinter
                .printIndividualTickets(
                    this.order,
                    container.currentDevice.device.printTickets, // Does the device have a souvenir (Boca) printer?
                )
                .catch((e) => {
                    console.error('Failed to print individual tickets', e);
                })
                .finally(() => {
                    this.isPrinting = false;
                });
        },

        printGroupTickets() {
            this.isPrinting = true;
            container.receiptPrinter
                .printGroupTickets(
                    this.order,
                    container.currentDevice.device.printTickets, // Does the device have a souvenir (Boca) printer?
                )
                .catch((e) => {
                    console.error('Failed to print group tickets', e);
                })
                .finally(() => {
                    this.isPrinting = false;
                });
        },
    },
};
